// ------------------------------------------------------
// MINE!
// ------------------------------------------------------

import _ from 'lodash/lodash';

const VueGps = {

  install (Vue) {
    // Expost on the instance of Vue
    Vue.prototype.$gps = VueGps;
    // Vue.$gps = VueGps;
  },

  getLocation: function(options) {

    options = _.isPlainObject(options) ? options : {};

    // return Promise.reject({name: 'GeoLocationError', message: 'This is a test error...'});

    if ('geolocation' in navigator) {

      return new Promise((resolve, reject) => {

        // Our options object has some extra fields (progress callbacks etc.) so we'll need to extract params that are for the actual geolocation call.
        // Note that we exclude the "timeout" key here since we're using an Infiniter timeout behind the scenes to keep getting a better position
        // (we have an abort callback that manually stops the lookup after timeout milliseconds - or when a satisfactory location accuracy has been received)
        const geoOptions = ['enableHighAccuracy', 'maximumAge'];

        const progressCallback = (typeof options.progress === 'function') ? options.progress : false;
        const desiredAccuracy = _.isInteger(options.accuracy) ? options.accuracy : 50;
        let positionOptions = _.pickBy(options, (value, key) => {

          return (geoOptions.indexOf(key) > -1) ? true : false;
        });

        positionOptions = _.extend({enableHighAccuracy: true, maximumAge: 0}, positionOptions, {timeout: Infinity});

        // We have a custom abort timeout since we may or may not receive a location that satisfies desired accuracy
        const timeout = _.isInteger(options.timeout) ? options.timeout : 30000;

        // Record the most accurate position encountered
        let iterationCount = 0, bestPosition, watchID, timerID;

        const watchSuccessCallback = function(position) {

          // Try to skip the first position returned
          // (some devices seem to return cached location regardless of maximumAge of 0)
          if ( ! bestPosition || iterationCount == 1) {

            bestPosition = position;
          }
          else {

            if (position.coords.accuracy < bestPosition.coords.accuracy) {

              bestPosition = position;
            }

            // We can abort if we've got the desired level of accuracy
            if (position.coords.accuracy <= desiredAccuracy) {

              window.clearTimeout(timerID);
              navigator.geolocation.clearWatch(watchID);

              return resolve(bestPosition);
            }
            else {

              // Allows the app to report on currently determined position and accuracy during the loop.
              if (typeof progressCallback === 'function') progressCallback(position);

              // Emit an event with the updated position data
              // (may require polyfill in older IE/Safari)
              if (typeof window.CustomEvent === "function") {

                const event = new CustomEvent("vue.gps.position", {
                  'gps': {'position': position}
                });

                document.dispatchEvent(event);
              }
            }
          }

          iterationCount++;
        };

        const watchFailureCallback = function(error) {

          window.clearTimeout(timerID);
          navigator.geolocation.clearWatch(watchID);

          return reject(new Error(error.message));
        };

        const watchAbort = function() {

          window.clearTimeout(timerID);
          navigator.geolocation.clearWatch(watchID);

          return bestPosition ? resolve(bestPosition) : reject({name: 'GeoLocationError', message: 'Failed to determine location'});
        };

        watchID = navigator.geolocation.watchPosition(watchSuccessCallback, watchFailureCallback, positionOptions);

        // We'll need to abandon the lookup eventually - at which point we may or may not have a suitable location + accuracy.
        timerID = setTimeout(watchAbort, timeout);
      });
    }
    else return Promise.reject({name: 'GeoLocationError', message: 'Geolocation is not available on this device.'});
  }
}

export default VueGps;


// WEBPACK FOOTER //
// ./src/plugins/VueGps.js